import React from 'react';
import { useParams } from "react-router";
import moment from "moment";


export const RenderFaultHistory = ({ faultHistory }) => {

  const params = useParams();

  const getNoFaultText = () => {
    let tab = params.type === "customerfacilityfault"
      ? "cff"
      : params.type === "customertrainfault"
        ? "ctf"
        : "cs";

    if (tab == "cff" || tab == "ctf") {
      return "Fault not modified yet."
    } else {
      return "Customer Suggestion not modified yet."
    }
  }

  return (
    <div className="fault-history">
      <div className="accordion" id="accordionExample">
        {faultHistory.length ? (
          faultHistory.map((fault, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-history-header" id={"headingOne"}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  <span className="active-history">{fault.userName}</span>
                  modified{" "}
                  <span className="active-history">{fault.columnName}</span>
                  <span className="active-history-date">
                    {" "}
                    on {" "}
                    {moment(fault.dateTimeStamp).format("DD-MM-YYYY HH:mm")}
                    {" "}
                  </span>
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <table className="table table-condensed">
                    <tbody>
                      <tr>
                        <th>Previous Value</th>
                        <th>Changed Value</th>
                      </tr>
                      <tr>
                        <td className="col-xs-6">{fault.previousValue}</td>
                        <td className="col-xs-6 ">{fault.currentValue}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-user">
            <i className="zmdi zmdi-block"></i>{getNoFaultText()}
          </div>
        )}
        {/* <div className="accordion-item">
            <h2 className="accordion-history-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <span className="active-history">
                  {faultDetail.Name ? "test" : ""}
                </span>
                modified <span className="active-history">Status</span>
                <span className="active-history-date"> on {date} </span>
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <table className="table table-condensed">
                  <tbody>
                    <tr>
                      <th>Previous Value</th>
                      <th>Changed Value</th>
                    </tr>
                    <tr>
                      <td className="col-xs-6">In&nbsp;Progress</td>
                      <td className="col-xs-6 ">Complete</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> */}
      </div>
    </div>
  );
};